import PropTypes from 'prop-types'
import { Component } from 'react'
import _ from 'lodash'

import template from './template.rt'
import './styles.css'

export class Merch extends Component {
  getSelectedVariant() {
    return _.find(this.props.variants, { selected: true })
  }

  render() {
    return template.call(this)
  }
}
export const merchPropType = {
  description: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  photo: PropTypes.shape({
    original: PropTypes.string.isRequired
  }).isRequired,
  previewPhoto: PropTypes.shape({
    large: PropTypes.string.isRequired
  }).isRequired,
  variants: PropTypes.arrayOf(
    PropTypes.shape({
      inStock: PropTypes.bool,
      name: PropTypes.name,
      owned: PropTypes.bool,
      price: PropTypes.number.isRequired,
      regularPrice: PropTypes.number.isRequired,
      selected: PropTypes.bool,
      url: PropTypes.string.isRequired
    })
  ).isRequired
}

Merch.propTypes = merchPropType

export default Merch
